module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"choose-service":"Choose Service","speed":"Speed","is-collection":"Is Collection","printer-required":"Printer Required","purchase-service":"Purchase Service","link":"Link","failed-select-service":"Failed to select service"}}')
  delete Component.options._Ctor
}
